<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {};
    },
    computed: {
        ...mapState('analyzeDeforestationStore', ['reports'])
    }
};
</script>

<template>
    <div id="captions">
        <div id="resume">
            <ul>
                <li>
                    <strong>Aguardando Análise:</strong>
                    {{ reports.meta?.totalAguardandoAnalise || 0 }}
                </li>
                <li>
                    <strong>Em Análise:</strong>
                    {{ reports.meta?.totalEmAnalise || 0 }}
                </li>
                <li>
                    <strong>Processadas:</strong>
                    {{ reports.meta?.totalProcessadas || 0 }}
                </li>
                <li>
                    <strong>Total:</strong>
                    {{ reports.meta?.total || 0 }}
                </li>
            </ul>
        </div>
        <div id="status">
            <ul>
                <li>Restando 48 horas</li>
                <li>Restando 24 horas</li>
                <li>Restando 12 horas</li>
            </ul>
        </div>
    </div>
</template>

<style scoped lang="scss">
#captions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    @media (max-width: 1024px) {
        flex-direction: column;
        align-items: start;
    }

    #resume {
        ul {
            list-style-type: none;
            padding: 0;
            margin: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            @media (max-width: 1024px) {
                flex-direction: column;
                align-items: start;
                margin-bottom: 20px;
            }
            li {
                color: var(--primary);
                display: flex;
                align-items: center;
                margin-right: 10px;
                gap: 5px;
            }
        }
    }

    #status {
        ul {
            list-style-type: none;
            padding: 0;
            margin: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            @media (max-width: 1024px) {
                flex-direction: column;
                align-items: start;
            }
            li {
                display: flex;
                align-items: center;
                margin-right: 10px;
                &:before {
                    content: '';
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    margin-right: 5px;
                }
                &:nth-child(1):before {
                    background-color: var(--success);
                    border-radius: 100%;
                }
                &:nth-child(2):before {
                    background-color: var(--warning);
                    border-radius: 100%;
                }
                &:nth-child(3):before {
                    background-color: var(--danger);
                    border-radius: 100%;
                }
            }
        }
    }
}
</style>
